import React from 'react';
import CharityCarousel from './CharityCarousel';

const ShareSection = () => {
  return (
    <section className="w-full px-2 mx-auto my-2 lg:px-4 xl:px-6">
      <div className="flex items-center justify-center gap-4 sm:gap-6 lg:gap-10 mb-3 sm:mb-4 md:mb-8">
        <div className="flex-grow h-0 border-b-2 border-orange-200"></div>
        <h2
          className="text-lg sm:text-xl md:text-2xl lg:text-[30px] font-bold text-center uppercase leading-tight flex-shrink-0"
          style={{
            color: '#fe6601',
          }}
        >
          HOẠT ĐỘNG THIỆN NGUYỆN GK88
        </h2>
        <div className="flex-grow h-0 border-b-2 border-orange-200"></div>
      </div>
      <div className="w-full mx-auto border-2 border-[#f9ab6b8a] rounded-2xl font-medium p-4 sm:p-5 mb-5">
        <p
          className="text-sm sm:text-base"
          style={{ color: 'rgb(33, 37, 41)', textAlign: 'justify', lineHeight: 'normal' }}
        >
          GK88 mời bạn đồng hành cùng chúng tôi bằng những hành động giản dị nhưng đầy ý nghĩa, như
          chia sẻ bài viết. Với mỗi lượt chia sẻ, Quỹ sẽ quy đổi tương ứng thành một khoản hỗ trợ
          (VD: 50.000 VNĐ/lượt chia sẻ).
          <br />
          <br />
          Hành động nhỏ của bạn hôm nay chính là nền tảng vững chắc cho những thay đổi lớn lao ngày
          mai. GK88 luôn sẵn sàng đồng hành cùng bạn, để mỗi chia sẻ hôm nay trở thành tia hy vọng
          của ngày mai. ❤️
        </p>
      </div>
      <CharityCarousel />
    </section>
  );
};

export default ShareSection;
